import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import { TranslationKey } from '../../utils/translations';

interface TranslatedTextProps {
  textKey: TranslationKey;
  className?: string;
}

/**
 * A component that renders translated text using the provided translation key
 * If the text contains newlines, it will render each paragraph in a separate p element
 */
const TranslatedText: React.FC<TranslatedTextProps> = ({ 
  textKey,
  className
}) => {
  const { t } = useTranslation();
  const text = t(textKey);
  
  // If the text contains newlines, split it and render each paragraph separately
  if (text.includes('\n')) {
    return (
      <>
        {text.split('\n').filter(paragraph => paragraph.trim() !== '').map((paragraph, index) => (
          <p key={index} className={className}>{paragraph.trim()}</p>
        ))}
      </>
    );
  }
  
  // Otherwise, render as a single piece of text
  return <>{text}</>;
};

export default TranslatedText; 